import Destinations from "./Destinations";
import DestinationsReducer from "./reducer";
import {
  setDestinationsView,
  setSelectedDestinations,
  SET_SELECTED_DESTINATIONS,
  SET_SELECTED_DESTINATION,
  SET_DESTINATIONS_VIEW,
} from "./actions";

export {
  Destinations,
  setDestinationsView,
  setSelectedDestinations,
  DestinationsReducer,
  SET_SELECTED_DESTINATIONS,
  SET_SELECTED_DESTINATION,
  SET_DESTINATIONS_VIEW,
};
